import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { NivelesService } from '../../_services/niveles.service';
import { UsuariosService } from '../../_services/usuarios.service';
import { Usuario } from '../../_models/usuario';
import { Table } from 'primeng/table';
import { NivelTasaService } from '../../_services/nivel-tasa.service';
import { NivelTasa } from '../../_models/nivel-tasa';
import { FormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { Nivel } from '../../_models/nivel';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-nivel-rango-tasa-usuario',
  templateUrl: 'niveles-rango-tasa-usuario.component.html'
} )

export class NivelesRangoTasaUsuarioComponent implements OnInit {

  @Input()
  nivel: Nivel;
  columnas: any[] = [];
  @ViewChild('dt') t: Table;

  //
  nivelesTasas: NivelTasa[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  cargandoTabla = false;
  puedeDeshabilitarIndicador = true;
  nombreValido = true;
  tasaValida = true;

  constructor(
    private route: ActivatedRoute,
    private nivelesServicio: NivelesService,
    private nivelTasaService: NivelTasaService,
    private usuarioService: UsuariosService,
    private navService: NavService,
    private location: Location,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nombre', header: this.navService.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'tasaMinima', header: this.navService.buscarMensaje( 'NIVELES.LBL_TASAMINIMA' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    if ( this.nivel ) {
      this.refrescar();
    }

  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario( nivelTasa?: NivelTasa ) {
    this.puedeDeshabilitarIndicador = true;
    this.submitted = false;
    this.tasaValida = true;
    this.nombreValido = true;
    this.formulario = this.fb.group( {
      idNivelTasa: [ nivelTasa ? nivelTasa.idNivelTasa : null, [] ],
      idNivel: [ this.nivel.idNivel, [ Validators.required ] ],
      nombre: [ nivelTasa ? nivelTasa.nombre : null, [ Validators.required ] ],
      tasaMinima: [ nivelTasa ? nivelTasa.tasaMinima : null, [ Validators.required ] ],
      indicadorHabilitado: new UntypedFormControl( {
        value: !nivelTasa || nivelTasa.indicadorHabilitado,
        disabled: nivelTasa && !this.puedeDeshabilitarIndicador
      }, [ Validators.required ] )
    } );
  }

  validarUnicoNombre( value ) {
    value = value ? value.toLowerCase() : '';
    this.nombreValido = this.nivelesTasas.find( x => x.nombre.toLowerCase() === value ) === undefined;
  }

  validarUnicaTasa( value ) {
    this.tasaValida = this.nivelesTasas.find( x => x.tasaMinima === Number( value ) ) === undefined;
  }

  validarTasaNoUtilizada( idNivelTasa: string ) {
    this.usuarioService.obtenerPorIdNivelTasa( idNivelTasa )
      .subscribe( ( x: Usuario[] ) => this.puedeDeshabilitarIndicador = x.length === 0 );
  }

  guardar() {
    this.submitted = true;
    if ( this.formulario.invalid || !this.nombreValido || !this.tasaValida ) {
      return;
    }
    this.submitted = false;
    if ( this.f.idNivelTasa.value ) {
      this.nivelTasaService.actualizar( this.formulario.value )
        .subscribe( () => {
          this.refrescar();
          this.navService.setMesage( 2,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'NIVELES.LBL_REGGUAR' )
            } );
        } );
    } else {
      this.nivelTasaService.agregar( this.formulario.value )
        .subscribe( () => {
          this.refrescar();
          this.navService.setMesage( 1,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'NIVELES.LBL_REGGUAR' )
            } );
        } );
    }
  }

  editar( row: NivelTasa ) {
    this.validarTasaNoUtilizada( row.idNivelTasa );
    this.cargarFormulario( row );
  }

  limpiar() {
    if ( this.formulario.dirty ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'niveles',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.cargarFormulario( null );
        },
        reject: () => {
        }
      } );
    } else {
      this.cargarFormulario( null );
    }
  }

  refrescar() {
    // bool para spinner de cargar pantalla
    this.cargandoTabla = true;

    // Llamar a refrescar datatable
    this.cargarFormulario( null );
    this.nivelTasaService.obtenerPorIdNivel( this.nivel.idNivel )
      .subscribe( res => {
        this.nivelesTasas = res;
        this.cargandoTabla = false;
      } );
  }

  atras() {
    this.location.back();
  }

}
